import { Modal } from "common/Modal"
import { downloadFileUrl } from "utils/evoTripsUi"

type FilePreview = { url: string; fileName?: string }

type Props = {
    showModal: boolean
    setShowModal: (value: boolean) => void
    imageUrl: string
    file?: FilePreview | null
}

export const ImagePreviewModal = ({ showModal, setShowModal, imageUrl, file }: Props) => {
    const handleDownload = () => {
        if (!file?.url) return
        downloadFileUrl(file.url, file.fileName || "image")
    }

    return (
        <Modal
            showModal={showModal}
            setShowModal={setShowModal}
            title={file?.fileName || "Image Preview"}
            width="w-full md:w-1/3"
        >
            {imageUrl && (
                <div className="space-y-4">
                    <div className="flex justify-center">
                        <img
                            src={imageUrl}
                            alt={file?.fileName || "Preview"}
                            className="max-w-full h-auto rounded-lg shadow-lg"
                        />
                    </div>
                    {file && (
                        <div className="flex justify-center gap-3">
                            <a
                                href={file.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
                            >
                                Open in New Tab
                            </a>
                            <button
                                type="button"
                                onClick={handleDownload}
                                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                            >
                                Download
                            </button>
                        </div>
                    )}
                </div>
            )}
        </Modal>
    )
}
